
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabpune() {



  const cardData =
  {
    keyword: 'One Way Cab Pune',
    heading: 'AB Ghule Cabs: One Way Cab Pune',
    headingDescription: 'Looking for a convenient and affordable one-way cab service in Pune? AB Ghule Cabs offers reliable, comfortable, and hassle-free one-way taxi services to various destinations from Pune. Whether you’re traveling for business, leisure, or personal reasons, our well-maintained fleet and experienced drivers ensure a safe and pleasant journey.',

    top: 'Top Destinations for One Way Cabs from Pune with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Mumbai",
    description: "Travel to the bustling city of Mumbai with ease. Visit iconic landmarks like Gateway of India, Marine Drive, and Siddhivinayak Temple."
  },
  {
    title: "Lonavala",
    description: "Enjoy a scenic drive to Lonavala, a popular hill station known for its lush greenery, waterfalls, and attractions like Bhushi Dam and Tiger's Leap."
  },
  {
    title: "Mahabaleshwar",
    description: "Head to the serene hill station of Mahabaleshwar to experience its breathtaking viewpoints, strawberry farms, and cool climate."
  },
  {
    title: "Shirdi",
    description: "Plan a spiritual journey to Shirdi, home to the revered Sai Baba Temple, and enjoy a peaceful visit to this holy town."
  },
  {
    title: "Goa",
    description: "Travel to the vibrant beaches of Goa and enjoy its lively nightlife, Portuguese architecture, and delicious seafood."
  },
  {
    title: "Kolhapur",
    description: "Visit Kolhapur to explore its rich heritage, including the famous Mahalaxmi Temple and Rankala Lake."
  },
  {
    title: "Aurangabad",
    description: "Discover the historical city of Aurangabad, home to the UNESCO World Heritage Sites of Ajanta and Ellora Caves."
  },
  {
    title: "Pune to Satara",
    description: "Take a one-way trip to Satara and explore its stunning landscapes, including the famous Kaas Plateau, known as the Valley of Flowers."
  },
  {
    title: "Nashik",
    description: "Visit Nashik, a city famous for its vineyards, temples, and the holy Kumbh Mela."
  },
  {
    title: "Bangalore",
    description: "Opt for a one-way journey to the tech hub of Bangalore, known for its modern amenities and cultural landmarks."
  }
],


services: [
    {
      "name": "Pune to Shirdi One-Way Cab",
      description: "Book a one-way cab from Pune to Shirdi for a peaceful and comfortable journey. Whether you’re visiting for a religious trip, pilgrimage, or just a getaway, our well-maintained cabs ensure a smooth and hassle-free ride. Enjoy a comfortable ride with experienced drivers familiar with the best routes, ensuring you reach Shirdi relaxed and on time. Our services are tailored for those looking for a serene and peaceful trip."
    },
    {
      "name": "One-Way Cab from Pune to Mumbai",
      description: "Traveling from Pune to Mumbai? Our one-way cab service is the ideal option for a direct, comfortable, and stress-free journey. Skip the hassles of crowded trains and buses, and enjoy a reliable, timely, and relaxing ride with our professional drivers. Our cabs are well-maintained and equipped for a smooth ride, making it the perfect solution for business travelers, tourists, or anyone seeking comfort and convenience."
    },
    {
      "name": "One-Way Cab from Mumbai to Pune",
      description: "Need to travel from Mumbai to Pune? Our one-way taxi service ensures a convenient, stress-free ride. Whether you’re heading to Pune for business, leisure, or personal reasons, we offer reliable and punctual service. Enjoy a comfortable journey with experienced drivers who know the fastest and safest routes. Avoid the chaos of public transport and enjoy a personalized experience with our well-maintained vehicles."
    },
    {
      "name": "Pune to Aurangabad One-Way Cab",
      description: "Planning to visit Aurangabad? Book a one-way cab from Pune to Aurangabad and enjoy a comfortable, safe, and affordable journey. Our cabs are perfect for long-distance trips, offering ample space and modern amenities to make your journey enjoyable. Whether you’re visiting historical sites, temples, or exploring the city, our experienced drivers ensure a smooth and relaxed ride to your destination."
    },
    {
      "name": "One-Way Taxi from Shirdi to Pune",
      description: "If you’re returning from Shirdi to Pune, book a one-way taxi from Shirdi to Pune. We offer affordable fares, experienced drivers, and a comfortable ride for your journey. Enjoy a stress-free trip as we ensure your return is just as peaceful as your visit to Shirdi. Our reliable service means you don’t need to worry about the journey, just sit back, relax, and let our professional drivers take care of everything."
    },
    {
      "name": "One-Way Cab from Pune to Kolhapur",
      description: "Traveling from Pune to Kolhapur? Our one-way cab service offers the convenience of a direct, comfortable, and hassle-free journey. Whether you’re heading to Kolhapur for business, family visits, or religious purposes, our well-maintained cabs provide a smooth ride. With affordable fares and professional drivers, you can relax and enjoy the scenic route, knowing you'll reach Kolhapur comfortably and on time."
    },
    {
      "name": "One-Way Cab from Pune to Mahabaleshwar",
      description: "Looking for a scenic trip to Mahabaleshwar? Our one-way cab from Pune to Mahabaleshwar is perfect for those wanting to escape to the hill stations. Enjoy a peaceful and smooth drive through the hills, with breathtaking views along the way. Our well-maintained vehicles and friendly drivers ensure a comfortable journey, making your visit to Mahabaleshwar a memorable experience. Book in advance to secure the best rates and ensure a hassle-free trip."
    },
    {
      "name": "One-Way Taxi from Pune to Goa",
      description: "Traveling to Goa for a vacation or business? Our one-way taxi service from Pune to Goa offers a comfortable and relaxing trip to the beautiful beaches. Skip the long, tiring bus rides or train journeys and opt for a personalized and convenient travel experience. With professional drivers who are familiar with the best routes, we ensure a smooth and timely arrival at your destination. Our cabs are equipped for a long-distance journey, providing you comfort throughout the trip."
    },
    {
      "name": "One-Way Taxi Fare Pune to Goa",
      description: "Wondering about the cost? The one-way taxi fare from Pune to Goa varies depending on the vehicle type, time of travel, and the season. We offer competitive prices and ensure value for money with no hidden charges. Whether you prefer an economy ride or a luxury experience, we provide a detailed breakdown of all expenses, so you know exactly what to expect. Our transparent pricing ensures that you get the best service at an affordable price."
    },
    {
      "name": "Pune to Kolhapur One-Way Cab",
      description: "Whether it’s a business trip, family visit, or religious journey, our one-way cabs from Pune to Kolhapur offer the ultimate convenience. With our direct travel service, you can avoid the hassle of multiple stops and reach your destination on time. The journey is comfortable, with well-maintained cabs and experienced drivers. Enjoy a stress-free ride and let us take care of your travel needs, making your journey as smooth as possible."
    },
    {
      "name": "One-Way Cab from Pune to Aurangabad",
      description: "Planning a short trip to Aurangabad? Our one-way taxi service from Pune to Aurangabad offers a comfortable, reliable, and direct ride. Whether you're visiting historical sites like the Ajanta and Ellora caves, or exploring local attractions, our service ensures that you travel in style and comfort. With experienced drivers who know the best routes, we guarantee a smooth and hassle-free ride to your destination."
    },
    {
      "name": "One-Way Drop Taxi from Pune",
      description: "Need a quick one-way drop? Our one-way drop taxi service from Pune ensures that you can reach your destination without any delay. Whether it’s a business meeting, an event, or a personal trip, our reliable drivers will ensure that you arrive on time. With modern and well-maintained vehicles, we provide a comfortable and safe ride for a smooth journey."
    },
    {
      "name": "One-Way Taxi Pune to Mumbai",
      description: "For a smooth, quick, and cost-effective journey, choose our one-way taxi from Pune to Mumbai. Whether you're traveling for business or leisure, we guarantee timely arrivals and a stress-free experience. Our professional drivers will ensure a smooth ride, avoiding the traffic and hustle associated with other travel options. Enjoy a comfortable and relaxed journey, knowing that you’re in safe hands."
    },
    {
      "name": "One-Way Taxi from Pune to Goa",
      description: "Heading to Goa for a vacation or a getaway? Our one-way taxi service from Pune to Goa offers the best comfort for long-distance travel. Our cabs are equipped with modern amenities and provide a relaxing ride, ensuring that you can unwind during the journey. Whether you're traveling solo or with friends or family, we ensure your trip is comfortable, safe, and stress-free."
    },
    {
      "name": "One-Way Car Rental from Pune",
      description: "Looking for a one-way car rental from Pune? We offer a wide range of vehicles available for one-way rentals at competitive rates. Whether it’s for business, leisure, or a family trip, we have the right vehicle to suit your needs. Choose from our fleet of well-maintained cars, including sedans, SUVs, and more, for a hassle-free rental experience. Enjoy the freedom to travel at your own pace with our flexible rental options."
    },
    {
      "name": "Pune to Mahabaleshwar One-Way Cab",
      description: "For a scenic hill station trip, book a one-way cab from Pune to Mahabaleshwar. We provide a comfortable ride with friendly drivers who know the best routes. Mahabaleshwar’s lush landscapes and cool weather make it the perfect getaway, and our one-way cab service ensures you get there in style. Enjoy the journey as much as the destination with our reliable and comfortable travel option."
    },
    {
      "name": "One-Way Cab Pune to Kolhapur",
      description: "Going to Kolhapur for a religious visit or vacation? Choose our one-way cab from Pune to Kolhapur and enjoy a stress-free ride. With professional drivers and a range of comfortable vehicles, we ensure your journey is smooth and timely. Whether you're traveling for business or personal reasons, we provide the best option for direct, safe, and convenient travel."
    },
    {
      "name": "Pune to Shirdi One-Way Cab",
      description: "If you're planning a visit to Shirdi, book a one-way cab from Pune to Shirdi. We provide an affordable, reliable, and comfortable ride for your pilgrimage or personal trip. With experienced drivers familiar with the best routes, you can be assured of a smooth, peaceful journey, ensuring that your visit to Shirdi is as tranquil as possible."
    },
    {
      "name": "One Way Cab Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient one-way cab services in Pune. Our friendly customer support team is available to assist you with bookings, provide information on rates, and ensure a smooth, hassle-free ride to your destination. Whether you're booking a cab for business or leisure, we ensure that every ride is comfortable and convenient."
    }
  ],

  tableData: [
    ["Pune to Shirdi cab one way", "-One way cab pune to mumbai"],
    ["One Way Cab Pune", "-One way cab mumbai to pune"],
    ["Mumbai pune cab one way", "-Pune to aurangabad cab one way"],
    ["pune to mumbai taxi one way", "-One way taxi mumbai to pune"],
    ["One way taxi from shirdi to pune", "-One way cab from pune to kolhapur"],
    ["One way cab from pune to mahabaleshwar", "-One way cab pune to kolhapur"],
    ["One way cab pune to aurangabad", "-One way car rental pune"],
    ["One way drop taxi pune", "-One way mumbai to pune"],
    ["Pune to aurangabad one way taxi", "-Pune to goa one way cab"],
    ["Pune to goa one way taxi", "-Pune to goa taxi fare one way"],
    ["Pune to kolhapur one way cab", "-Pune to mahabaleshwar one way cab"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Convenient Service",
      WhyChoosedescription: "AB Ghule Cabs offers reliable and convenient one-way cab services in Pune. Whether you're heading to another city or just need a one-way ride for a short trip, we ensure timely pickups and comfortable rides to your destination."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive and transparent pricing for all our one-way cab services. There are no hidden charges, and you’ll always know exactly what you’re paying for. Enjoy affordable rates with the best value for your money."
    },
    {
      WhyChooseheading: "Variety of Vehicles to Choose From",
      WhyChoosedescription: "Whether you're traveling solo or with a group, we have a wide range of vehicles to suit your needs. Choose from sedans, SUVs, luxury cars, or minivans based on your comfort and preferences."
    },
    {
      WhyChooseheading: "Experienced Drivers",
      WhyChoosedescription: "Our professional drivers are well-trained, experienced, and courteous. They ensure a smooth and safe journey with excellent road knowledge, making your one-way trip in Pune a stress-free experience."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether it’s early in the morning or late at night, AB Ghule Cabs operates 24/7, ensuring that you have access to our one-way cab services at any time. Our customer support is always available for bookings or inquiries."
    },
    {
      WhyChooseheading: "Easy and Hassle-Free Booking",
      WhyChoosedescription: "Booking your one-way ride is simple with AB Ghule Cabs. You can book through our website, mobile app, or by calling our customer service team. We make sure you have a smooth and quick booking experience."
    },
    {
      WhyChooseheading: "Timely Pickup and Drop",
      WhyChoosedescription: "Our drivers ensure punctual pick-up and drop-off for your one-way journey. We value your time, so you can count on us to get you to your destination on time, every time."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How do I book a one-way cab in Pune?',
      answer: 'You can easily book a one-way cab through our website, mobile app, or by calling our customer service team.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way cab ride within Pune?',
      answer: 'The fare for a one-way ride within Pune starts from ₹1,200 for a sedan, depending on the location.',
    },
    {
      id: 'FAQ3',
      question: 'Are the one-way cab prices fixed?',
      answer: 'The prices are indicative and may vary depending on factors like the vehicle type, travel time, and distance.',
    },
    {
      id: 'FAQ4',
      question: 'How long will it take for my cab to arrive?',
      answer: 'Once you book the cab, our drivers will arrive at your location promptly, usually within 15-30 minutes depending on traffic conditions.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a one-way cab for intercity travel?',
      answer: 'Yes, we offer one-way cabs for intercity travel as well. You can book cabs from Pune to nearby cities like Mumbai, Nashik, and more.',
    },
    {
      id: 'FAQ6',
      question: 'How do I pay for my one-way ride?',
      answer: 'Payments can be made via cash, credit/debit card, or online payment through our mobile app.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are air-conditioned for your comfort during the ride.',
    },
    {
      id: 'FAQ8',
      question: 'Is there an extra charge for waiting?',
      answer: 'Yes, additional charges may apply for waiting time. However, any extra charges will be communicated to you in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arjun Patil',
      feedback: 'I recently booked a one-way cab from Pune to Mumbai, and I had an excellent experience. The driver was professional, and the ride was smooth. I will definitely choose AB Ghule Cabs for my future trips!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Simran Gupta',
      feedback: 'I needed a one-way ride from Pune to Nashik for an urgent business trip. AB Ghule Cabs made it easy to book, and the driver was on time. Great service and hassle-free journey!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | One Way Cab Pune | Affordable Taxi & Car Rental</title>
  <meta name="description" content="Book a one-way cab from Pune to various destinations with AB Ghule Cabs. Affordable and reliable one-way taxi services for Shirdi, Mumbai, Goa, Kolhapur, and more. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="One Way Cab Pune, Pune to Shirdi Cab One Way, One Way Cab Pune to Mumbai, One Way Cab Pune, One Way Cab Mumbai to Pune, Mumbai Pune Cab One Way, Pune to Aurangabad Cab One Way, Pune to Mumbai Taxi One Way, One Way Taxi Mumbai to Pune, One Way Taxi from Shirdi to Pune, One Way Cab from Pune to Kolhapur, One Way Cab from Pune to Mahabaleshwar, One Way Cab Pune to Kolhapur, One Way Cab Pune to Aurangabad, One Way Car Rental Pune, One Way Drop Taxi Pune, One Way Mumbai to Pune, Pune to Aurangabad One Way Taxi, Pune to Goa One Way Cab, Pune to Goa One Way Taxi, Pune to Goa Taxi Fare One Way, Pune to Kolhapur One Way Cab, Pune to Mahabaleshwar One Way Cab" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | One Way Cab Pune | Affordable Taxi & Car Rental" />
  <meta property="og:description" content="Book a one-way cab from Pune to various destinations with AB Ghule Cabs. Affordable and reliable one-way taxi services for Shirdi, Mumbai, Goa, Kolhapur, and more. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/one-way-cab-pune.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/one-way-cab-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - One Way Cab Pune",
        description: "Book a one-way cab from Pune to various destinations with AB Ghule Cabs. Affordable and reliable one-way taxi services for Shirdi, Mumbai, Goa, Kolhapur, and more. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/one-way-cab-pune",
        "logo": "https://abghulecabs.com/images/one-way-cab-pune.jpg",
        "image": "https://abghulecabs.com/images/one-way-cab-pune.jpg",
        "priceRange": "₹3000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/one-way-cab-pune",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-09-15",
            "reviewBody": "I used AB Ghule Cabs for a one-way trip to Goa. The car was comfortable, and the driver was very professional. Highly recommend!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anil R"
            },
            "datePublished": "2024-06-28",
            "reviewBody": "Affordable rates for a one-way trip from Pune to Shirdi. The service was top-notch, and I felt safe throughout the journey."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Various Destinations One Way Cab Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/one-way-cab-pune"
        },
        "keywords": "One Way Cab Pune, Pune to Shirdi Cab One Way, One Way Cab Pune to Mumbai, One Way Cab Pune, One Way Cab Mumbai to Pune, Mumbai Pune Cab One Way, Pune to Aurangabad Cab One Way, Pune to Mumbai Taxi One Way, One Way Taxi Mumbai to Pune, One Way Taxi from Shirdi to Pune, One Way Cab from Pune to Kolhapur, One Way Cab from Pune to Mahabaleshwar, One Way Cab Pune to Kolhapur, One Way Cab Pune to Aurangabad, One Way Car Rental Pune, One Way Drop Taxi Pune, One Way Mumbai to Pune, Pune to Aurangabad One Way Taxi, Pune to Goa One Way Cab, Pune to Goa One Way Taxi, Pune to Goa Taxi Fare One Way, Pune to Kolhapur One Way Cab, Pune to Mahabaleshwar One Way Cab"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/56.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onewaycabpune;